import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import { addLongCall, addLongPut, addShortCall, addShortPut } from './addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
  getStrikeDistance,
} from './utils';

export const inverseIronCondor: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  const sellPutStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: -2 }),
  );
  const buyPutStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: -1 }),
  );
  const buyCallStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: 1 }),
  );
  const sellCallStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: 2 }),
  );

  return {
    optionPositions: [
      addShortCall({
        strike: sellCallStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[sellCallStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[sellCallStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      addShortPut({
        strike: sellPutStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[sellPutStrike]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[sellPutStrike]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      addLongCall({
        strike: buyCallStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[buyCallStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[buyCallStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      addLongPut({
        strike: buyPutStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[buyPutStrike]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[buyPutStrike]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [],
  };
};
